/* Aircraft Adapters page. Port of the prototype's adapter.js: "What do you fly?" then
   "Which Robotow do you own?", with the frame rule from the brand canon (an adapter fits the
   same frame style only). A mismatch or an older Robotow is "Confirm with us", never a guess. */
(function () {
  "use strict";
  var root = document.querySelector("[data-rt-adapters]");
  if (!root) return;
  var Fit = window.RobotowFit;
  var DATA = JSON.parse(root.querySelector("[data-adapter-data]").textContent);
  var bySku = {}; DATA.variants.forEach(function (v) { bySku[v.sku] = v; });
  var result = root.querySelector("[data-adapter-result]");
  var FRAME = { "6500": "standard frame (straight handle)", "6600": "Pro frame", "6700": "SF frame (short frame)" };
  var esc = function (t) { return Fit.esc(t); };
  function phone() { var c = Fit.config(); return { d: c.phoneDisplay || "", t: "tel:" + (c.phoneTel || "") }; }

  function card(html, kind) {
    return '<div class="rt-kit-answer is-' + kind + '">' + html + "</div>";
  }
  function line(kind, text) {
    return '<p class="rt-kit-answer-line">' + Fit.glyph(kind) + "<span>" + text + "</span></p>";
  }

  function ownerQuestion(a) {
    var opts = [["6500", "Robotow 2.0, standard frame (straight handle)"], ["6600", "Robotow 2.0 Pro (folds)"], ["6700", "Robotow 2.0 SF (short frame)"],
      ["earlier", "An earlier Robotow (28VL, 24SL or older)"], ["unsure", "I am not sure"], ["none", "I do not own one yet"]];
    result.innerHTML = '<div class="rt-owner-q"><p class="rt-kit-step-label" id="rt-own-q">Which Robotow do you own?</p>' +
      '<p class="rt-opt-text">The adapter has to match the frame style. This question prevents a wrong part.</p>' +
      '<div class="rt-fits-states" role="group" aria-labelledby="rt-own-q">' +
      opts.map(function (o) { return '<button type="button" class="rt-pill-light" aria-pressed="false" data-own="' + o[0] + '">' + o[1] + "</button>"; }).join("") +
      "</div><div data-own-answer></div></div>";
    Array.prototype.forEach.call(result.querySelectorAll("[data-own]"), function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(result.querySelectorAll("[data-own]"), function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        answer(a, b.getAttribute("data-own"));
      });
    });
  }

  function answer(a, own) {
    var out = result.querySelector("[data-own-answer]");
    var ad = Fit.getAdapter(a.adapter), v = ad ? bySku[ad.sku || ad.pn] : null, p = phone();
    var need = a.unit, kit = DATA.kitPath + "?ac=" + encodeURIComponent(a.id);
    if (own === "none") {
      out.innerHTML = card(line("yes", "Your adapter comes in the kit.") + "<p>Every Robotow 2.0 kit includes the adapter for your " + esc(a.display) + ".</p>" +
        '<div class="rt-actions"><a class="rt-btn rt-btn--signal" href="' + kit + '">Build my ' + esc(a.display) + " kit</a></div>", "fits");
      return;
    }
    if (own === "earlier" || own === "unsure" || own !== need) {
      var why = own === "earlier" ? "You own an earlier Robotow. Call with the model in front of you and we will match the adapter to your frame."
        : own === "unsure" ? "Tell us the model when you call, or send a photo of your Robotow, and we will match the adapter to your frame."
        : "The " + esc(ad.name) + " is made for the " + FRAME[need] + ". You own the " + FRAME[own] + ". Call and we will match the adapter to your frame before anything ships.";
      out.innerHTML = card(line("ask", "Confirm with us.") + "<p>" + why + "</p>" +
        '<div class="rt-actions"><a class="rt-btn rt-btn--signal" href="' + p.t + '" data-rt-phone-location="adapter">Call ' + esc(p.d) + '</a>' +
        '<a class="rt-btn rt-btn--ghost" href="' + DATA.contactPath + "?airplane=" + encodeURIComponent(a.display) + "&ac=" + encodeURIComponent(a.id) + '">Send photos</a></div>', "ask");
      return;
    }
    var price = v ? Fit.money(v.price) : "";
    var buy = DATA.sellOnline && v && v.available
      ? '<button type="button" class="rt-btn rt-btn--signal" data-adapter-add="' + v.id + '">Add the ' + esc(ad.name) + " to my cart" + (price ? " · " + price : "") + "</button>"
      : '<a class="rt-btn rt-btn--signal" href="' + p.t + '" data-rt-phone-location="adapter">Call ' + esc(p.d) + " to order it</a>";
    out.innerHTML = card(line("yes", "It matches.") + "<p>Your " + esc(a.display) + " takes the " + esc(ad.name) + ", part " + esc(ad.pn) + ", on the " + FRAME[need] + "." + (price ? " " + price + "." : "") + "</p>" +
      (ad.attach ? '<p class="rt-fit-meta"><b>How it attaches:</b> ' + esc(ad.attach) + "</p>" : "") +
      '<div class="rt-actions">' + buy + "</div>", "fits");
    var addBtn = out.querySelector("[data-adapter-add]");
    if (addBtn) addBtn.addEventListener("click", function () {
      addBtn.disabled = true;
      fetch(DATA.cartAddUrl, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(addBtn.getAttribute("data-adapter-add")), quantity: 1, properties: { Airplane: a.display } }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); window.location.href = DATA.cartUrl; })
        .catch(function () { addBtn.disabled = false; addBtn.insertAdjacentHTML("afterend", '<p class="rt-kit-error" role="alert">We could not add it. Call ' + esc(p.d) + ".</p>"); });
    });
    highlight(ad.pn);
  }

  function onAircraft(a) {
    var c = Fit.classify(a);
    if (c === "nofit" || c === "confirm-unconfirmed") { result.innerHTML = Fit.buildResultHTML(a); return; }
    ownerQuestion(a);
  }

  function highlight(pn) {
    Array.prototype.forEach.call(root.querySelectorAll(".rt-adapter-card"), function (el) { el.classList.toggle("is-picked", el.getAttribute("data-pn") === pn); });
  }

  function enrichGrid() {
    var d = Fit.data();
    Array.prototype.forEach.call(root.querySelectorAll(".rt-adapter-card"), function (el) {
      var ad = d.adapters[el.getAttribute("data-pn")];
      if (!ad) return;
      var all = d.aircraft.concat(Object.keys(d.variants || {}).map(function (k) { return d.variants[k]; }));
      var planes = all.filter(function (a) { return a.adapter === ad.pn && a.status === "listed"; }).map(function (a) { return a.display; });
      el.querySelector("[data-adapter-frame]").textContent = "For the " + FRAME[ad.unit] + ".";
      if (planes.length) el.querySelector("[data-adapter-planes]").textContent = "Fits: " + planes.join(", ") + ".";
      if (ad.attach) el.querySelector("[data-adapter-attach]").textContent = "How it attaches: " + ad.attach;
    });
    // Prefer a named card; otherwise map Shopify's variant link to its adapter part number.
    var params = new URLSearchParams(window.location.search);
    var pn = params.get("adapter");
    var cards = Array.prototype.slice.call(root.querySelectorAll(".rt-adapter-card"));
    var el = pn ? cards.filter(function (c) { return c.getAttribute("data-pn") === pn; })[0] : null;
    if (!el) {
      var selected = DATA.variants.filter(function (v) { return String(v.id) === params.get("variant"); })[0];
      pn = selected ? selected.sku : null;
      el = pn ? cards.filter(function (c) { return c.getAttribute("data-pn") === pn; })[0] : null;
    }
    if (el) {
      highlight(pn);
      el.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "auto" });
    }
  }

  root.addEventListener("rt:aircraft", function (e) { onAircraft(e.detail.aircraft); });
  if (Fit) Fit.ready(enrichGrid);
})();
